<template>
  <div id="worth">
    <!--本体-->
    <ul class="whiteB">
      <li class="o1rem arrow relativeItem" v-for="(n, index) in data" :key="index" >
        <router-link class="allA" :to="'/helptext' + '?id=' + n.id"></router-link>
        <p>{{ n.title }}</p>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "worth",
  data() {
    return {
      data:[],
    };
  },
  methods: {
    //获取个人信息
    helping() {
      let _this = this;
      let data = {
        cateid: 4
      }
      this.$jsonp(this.$apis("helping"), data, res => {
        _this.data = res.data.data.result.helps;
      });
    }
  },
  mounted: function() {
    this.$emit("showOhidden", false, 3);
    this.$tool.setTitle("帮助中心");
    this.helping();
  }
};
</script>

<style scoped>
li {
  padding: 0.7rem;
  padding-right: 2rem;
  text-align: justify;
  font-size: 14px;
  border-bottom: 1px solid #f4f4f4;
}
li :last-child{
  border: 0;
}
</style>
